import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import ClassesPage from "./pages/ClassesPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/classes" element={<ClassesPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
